import React from 'react';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';
import '../styles/components/Nerede.scss';

const Nerede = () => {
    const { ref, inView } = useInView({
        threshold: 0.2,
        triggerOnce: true
    });

    return (
        <section id="nerede" className="nerede-section gradient-bg combined-section">
            <div className="section-container" ref={ref}>
            <h2 className={`section-title ${inView ? 'fade-in' : ''}`}>
                    {/**/}
                </h2>
                <div className={`nerede-content ${inView ? 'slide-up' : ''}`}>
                    
                    <div className="nerede-text">
                        <div className="info-section">
                            <h3 className="info-title">Black owLs Gamıng Communıty Üyesi Olmak İçin;</h3>
                            
                            <div className="requirements-list">
                                <div className="requirement-item">
                                    <div className="requirement-icon">
                                        <img src="/assets/images/community.png" alt="Community" />
                                    </div>
                                    <p>
                                        Kaliteli oyun deneyimi ve topluluk etkinliklerine katılım için herkesin başvurabileceği eğlenceli, keyifli bir alan sunuyoruz.
                                    </p>
                                </div>

                                <div className="requirement-item">
                                    <div className="requirement-icon">
                                        <img src="/assets/images/character.png" alt="Character" />
                                    </div>
                                    <p>
                                        Düzgün karakterde, zararsız bir kişi olmanız yeterlidir.
                                    </p>
                                </div>

                                <div className="requirement-item">
                                    <div className="requirement-icon">
                                        <img src="/assets/images/social-media.png" alt="Social Media" />
                                    </div>
                                    <p>
                                        Başvuru ve daha detaylı bilgi almak için sosyal medya hesaplarımıza göz atabilirsin.
                                    </p>
                                </div>

                                <div className="requirement-item">
                                    <div className="requirement-icon">
                                        <img src="/assets/images/support.png" alt="Support" />
                                    </div>
                                    <p>
                                        Destek için herhangi bir <span className="red-text">@RED</span> oyuncumuzla iletişime geçebilirsiniz.
                                    </p>
                                </div>

                                <div className="requirement-item last-item">
                                    <p>
                                        Temelde, <span className="italic-text">"zeki, çevik ve ahlaklı"</span> bireyleri aramıza katmaya çalışıyoruz.
                                    </p>
                                </div>
                            </div>
                            <Link to="/takimbasvuru" className="social-button">
                                <span>Topluluğa Katıl</span>
                                <i className="arrow-icon"></i>
                            </Link>
                            {/* <p className="closing-text">Bol şans!</p> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Nerede;